import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import { AUTH_ROUTES } from "./constants/auth.constants";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage";
import { LoginPage } from "./pages/LoginPage";
import { RegisterPage } from "./pages/RegisterPage";
import { ResetCodePage } from "./pages/ResetCodePage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { ResetSuccessPage } from "./pages/ResetSuccessPage";

// Keeps the page the person was sent from (PrivateRoute's `from`) through the hop to the login form.
function ToLogin() {
  const { state } = useLocation();
  return <Navigate to={`/auth/${AUTH_ROUTES.LOGIN}`} replace state={state} />;
}

export const LoginNavigation = () => {
  return (
    <Routes>
      <Route path={AUTH_ROUTES.LOGIN} element={<LoginPage />} />
      <Route path={AUTH_ROUTES.REGISTER} element={<RegisterPage />} />
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD_VERIFY} element={<ResetCodePage />} />
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD_NEW} element={<ResetPasswordPage />} />
      <Route path={AUTH_ROUTES.FORGOT_PASSWORD_DONE} element={<ResetSuccessPage />} />
      <Route path="/*" element={<ToLogin />} />
    </Routes>
  );
};
